import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PermissionService, Section } from '../services/permission/permission.service';

export function sectionGuard(section: Section): CanActivateFn {
  return (): boolean | UrlTree => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    if (permissionService.canAccess(section)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}

export function manageSectionGuard(section: Section): CanActivateFn {
  return (): boolean | UrlTree => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    if (permissionService.canManage(section)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}
